export default "__VITE_ASSET__mCmhrABH__"